import React,{useEffect} from "react";
import defaultUserPic from "../assets/img/user-profile.svg";
// import groupPic from "../../assets/img/multi-user-icon.svg";

const UserProfileModal = ({ title, closeModal, user }) => {

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    };
  
    window.addEventListener("keydown", handleKeyDown);
  
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeModal]);
  return (
    <div className="modal-content Create-new-group-popup">
      <div className="modal-header">
        <label>{title}</label>
        <i
          className="fa fa-times-circle cursor-pointer"
          aria-hidden="true"
          onClick={closeModal}
        ></i>
      </div>
      <div className="modal-body profile-modal-body">
        <div className="profile-picture-wrapper">
          <img
            src={defaultUserPic}
            alt="Profile"
            className="profile-picture"
          />
        </div>

        <div className="profile-details">
          <div className="profile-field">
            <span className="field-label">Username:</span>
            <span className="field-value">
              {user.userName || "Not provided"}
            </span>
          </div>

          <div className="profile-field">
            <span className="field-label">Phone Number:</span>
            <span className="field-value">{user.mobile || "Not provided"}</span>
          </div>

        </div>
      </div>
      <div className="modal-footer modal-footer-groupcreate">
        <div>
          <button className="btn btn-primary" onClick={closeModal}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfileModal;
